(function () {
hubspot.define('hubspot.analytics.TrackingCode', ['enviro', 'hub-http/clients/apiClient'], function(Env, http) {
  return {
    get: function() {
      var scriptLoaderBaseUrl;
      if (Env.getShort('app') === 'qa') {
        scriptLoaderBaseUrl = '//js.hs-scriptsqa.com';
      } else {
        scriptLoaderBaseUrl = '//js.hs-scripts.com';
      }
      return "<!-- Start of HubSpot Embed Code -->\n  <script type=\"text/javascript\" id=\"hs-script-loader\" async defer src=\"" + scriptLoaderBaseUrl + "/" + hubspot.portal.id + ".js\"></script>\n<!-- End of HubSpot Embed Code -->";
    },
    getDefault: function() {
      return http.get('/activities/settings/v1/javascript/default-snippet');
    },
    getAdvanced: function() {
      return http.get('/activities/settings/v1/javascript/advanced-snippet');
    },
    install: function() {
      if (!Env.deployed('analytics')) {
        return console.log('[analytics_js] Please remove `TrackingCode.install()` from your application. The product is already tooled with the tracking code.');
      }
    }
  };
});
}());

